interface IProps {
  fill?: string;
}

function IConHotelRankingComponent({ fill = "#9C8B58" }: IProps) {
  return (
    <svg
      width="32"
      height="41"
      viewBox="0 0 32 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 32H32V41L16 32ZM0 32H16L0 41V32ZM0 32V0H32V32H0Z"
        fill={fill}
      />
    </svg>
  );
}

export { IConHotelRankingComponent };
